<template>
    <div class="mobileHome">
        <mHead :showSearch="true"></mHead>
        <div class="main">
            <img v-if="isUC" class="Img" src="@/assets/img/Group 137@2x.png" alt="">
            <video v-else id="videoDom" loop autoplay="autoplay" poster="@/assets/img/Group 137@2x.png" :src="homeObject.firstUrl.url" preload="preload" x5-video-player-type="h5-page" x5-playsinline="true"  webkit-playsinline="true" playsinline="true" x5-video-orientation="landscape|portrait"></video>
            <div class="consult">
                <div class="btn" @click="showCooperate=true">
                    前往咨询
                </div>
                <p>为企业赋能增效的创新型数字营销科技公司</p>
            </div>
            <div class="partners">
                <p>
                    合作客户
                </p>
                <img :src="homeObject.bottomImg.url" alt="">
            </div>
        </div>
        <mBottom></mBottom>
        <div class="cooperate" v-show="showCooperate">
            <img class="close" src="@/assets/img/ic_guanbi-2@2x.png" alt="" @click="showCooperate=false;">
            <div class="content">
                <img class="top" :src="homeObject.company.url" alt="">
                <div class="bottom">
                    <div class="info">
                        <p class="address">
                            <img src="@/assets/img/Group 158@2x.png" alt="">
                            <span>{{homeObject.company.address}}</span>
                        </p>
                        <p class="phone">
                            <img src="@/assets/img/Group 159@2x.png" alt="">
                            <span>{{homeObject.company.phone}}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div :class="'back' + (showCooperate? ' show': '')" @click="showCooperate=false"></div>
    </div>
</template>
<script src="http://res.wx.qq.com/open/js/jweixin-1.0.0.js"></script>
<script>
import mHead from '@/components/base/mobile/mHead.vue'
import mBottom from '@/components/base/mobile/mBottom.vue'
export default {
    name: 'mobileHome',
    components:{mHead,mBottom},
    data(){
        return {
            showCooperate: false,
            homeObject: {
                firstUrl: {url: ''},
                bottomImg: {
                    url: ''
                },
                company: {
                    address: '',
                    phone: '',
                    url: ''
                }
            },
            isUC: navigator.userAgent.indexOf('UBrowser') > -1
        }
    },
    mounted(){
        this.getList();
        this.statistics();
    },
    methods: {
        statistics(){
            this.$http.post(this.service.dev.api.statistics, {pageName: '首页'} ).then(response =>{
            })
        },
        getList(){
            this.$http.get(this.service.dev.api.recommendList+'?pageId=6' ).then(response =>{
              if(response.status == 200){
                  this.recommendList = response.body || []
                  this.formatData(response.body || [])
              } else {
                  this.$message.error(response.message?response.message:'error');
              }
            }).catch((res)=>{
                this.$message.error('error');
            })
        },
        playVideo(){
            let userAgent = navigator.userAgent;
            let isIOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 
            let video = document.getElementById('videoDom')
            if(isIOS){
                if(video){
                    video.play();
                    document.addEventListener('WeixinJSBridgeReady',()=>{
                        video.play();
                    }, false);
                }
            }
            let isUC = (navigator.userAgent.indexOf('UBrowser') > -1);
            if(isUC) {
                // video.style.width = (document.body.scrollWidth + 'px');
            }
        },
        formatData(list){
            list.map(item => {
                if(item.keyName == 'firstUrl') {
                    this.homeObject.firstUrl.url = item.content;
                    // this.homeObject.firstUrl.height = item.keyDesc;
                } else if(item.keyName == 'company') {
                    let company = JSON.parse(item.content)
                    this.homeObject.company.url = company.url;
                    this.homeObject.company.phone = company.phone;
                    this.homeObject.company.address = company.address;
                } else if (item.keyName == 'bottomImg') {
                    this.homeObject.bottomImg.url = item.content;
                    this.homeObject.bottomImg.height = item.keyDesc;
                }
            })
            setTimeout(()=>{
                this.playVideo()
            },1500)
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/style/base.scss";
.mobileHome {
    background: #000000;
    position: relative;
}
    .main {
        video {
            width: 100%;
            min-height: poToRem(400);
        }
        .Img {
            width: 100%;
        }
        .consult {
            width: 100%;
            padding: 0 poToRem(50) poToRem(13);
            color: #ffffff;
            box-sizing: border-box;
            .btn {
                width: 100%;
                border: poToRem(2) solid #ffffff;
                // border-radius: poToRem(63);
                padding-top: poToRem(13);
                padding-bottom: poToRem(13);
                font-size: poToRem(12);
                // font-weight: bold;
            }
            p {
                font-size: poToRem(8);
                color: rgba(255, 255, 255, 0.6);
                margin-top: poToRem(12);
            }
        }
        .partners {
            padding: poToRem(50) poToRem(20) poToRem(33);
            p {
                font-size: poToRem(20);
                color: #ffffff;
                font-weight: bold;
                margin-bottom: poToRem(30);
            }
            img {
                width: 100%;
            }
            text-align: center;
        }
    }
    .back {
        position: fixed;
        top: poToRem(54);
        left: 0;
        right: 0;
        bottom: 0;
        // background: rgba(0,0,0,0.9);
        z-index: 96;
        background: rgba(0,0,0,0.96);
        visibility: hidden;
        opacity: 0;
        transition: opacity .32s cubic-bezier(.4,0,.6,1) 80ms,visibility .32s step-end 80ms;
        &.show {
            visibility: visible;
            opacity: 1;
            transition: opacity .32s cubic-bezier(.4,0,.6,1) 80ms,visibility .32s step-start 80ms;
        }
    }
    .cooperate {
        width: 86vw;
        // height: 527px;
        margin: 0 auto;
        position: fixed;
        top: poToRem(160);
        left: 50%;
        transform: translateX(-43vw);
        z-index: 97;
        .close {
            position: absolute;
            right: 0;
            top: 0;
            width: poToRem(42);
            height: poToRem(42);
        }
        .content {
            width: 100%;
            background: #ffffff;
            .bottom {
                padding: poToRem(18) poToRem(18) poToRem(40);
                position: relative;
                width: 100%;
                box-sizing: border-box;
                .info {
                    .address,.phone {
                        text-align: left;
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        &:first-child {
                            margin-bottom: poToRem(10);
                        }
                        img {
                            width: poToRem(24);
                            height: poToRem(24);
                        }
                        span {
                            font-size: poToRem(16);
                            color: rgba(0,0,0,0.6);
                            // vertical-align: super;
                            margin-left: poToRem(8);
                        }
                    }
                }
            }
            .top {
                width: 100%;
                img{
                    width: 100%;
                    display: block;
                }
            }
        }
    }
</style>





// WEBPACK FOOTER //
// src/modules/view/home/mobile.vue